// Danske UI-tekster til deling af resultater (delt link, CSV-eksport).
const textsShare = {
  share: {
    button: 'Del resultat',
    linkCopied: 'Link kopieret',
    couldNotShare: 'Kunne ikke oprette delt link',
    csvGameLabel: 'Hent CSV',
    csvClubLabel: 'Hent sæson som CSV',
    notFoundTitle: 'Resultatet findes ikke',
    notFoundHint: 'Linket er forkert, eller resultatet er blevet fjernet.',
    backToStart: '← Til forsiden',
    poweredBy: 'Ført med WhistBuddy',
    loading: 'Henter resultat…',
    standingTitle: 'Stilling',
    pointsCurveTitle: 'Pointkurve',
    roundsTitle: 'Runder',
    round: (n: number) => `Runde ${n}`,
    tricksSuffix: 'stik',
    won: 'vundet',
    lost: 'tabt',
    completed: 'Afsluttet',
    active: 'I gang'
  }
}

export default textsShare
